import { render, staticRenderFns } from "./VincularContaUnidadeForm.vue?vue&type=template&id=1ffca3d5"
import script from "./VincularContaUnidadeForm.vue?vue&type=script&lang=js"
export * from "./VincularContaUnidadeForm.vue?vue&type=script&lang=js"
import style0 from "./VincularContaUnidadeForm.vue?vue&type=style&index=0&id=1ffca3d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports